import { render, staticRenderFns } from "./FlashAlert.vue?vue&type=template&id=279291b2&scoped=true&lang=pug&"
import script from "./FlashAlert.vue?vue&type=script&lang=js&"
export * from "./FlashAlert.vue?vue&type=script&lang=js&"
import style0 from "./FlashAlert.vue?vue&type=style&index=0&id=279291b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279291b2",
  null
  
)

export default component.exports